export default __webpack_public_path__ + "static/media/dragonisland.34a38e5f.png";